import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import { useNotifications } from 'src/notifications';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';

export const useDeleteShowing = () => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<void, IStandardErrorResponse, number>(
        async (showingId) => {
            await apiClient(`api/landlord/showings/${showingId}`, {
                method: 'delete',
            }).json();
        },
        {
            onSuccess: () => {
                addNotification('Tour deleted successfully!', 'success');
                queryClient.invalidateQueries(queryKeys.showings);
            },
            onError: (error) => {
                const errorMessage = error.msg || 'Failed to delete tour';
                addNotification(errorMessage, 'error');
            },
        }
    );
};
